<template lang="html">


    <div class="cover-popup row-center">
        <span class="close-cover" @click="$emit('close')"></span>
        <div class="popup">
            <a class="close" @click="$emit('close')">✕</a>
            <h2 class="title-pop">Rellena los siguientes campos para inscribirte</h2>
            <p><strong>Por favor revisa y confirma los siguientes datos para inscribirte.</strong></p>
            <div class="long-form row-between">
                <div class="contenedor-input -middle">
                    <label for="">Nombre*</label>
                    <input type="text" name="nombre"
                        v-model="inscripcion.nombre"
                        v-validate="'required'">
                    <span :class="['error',{'animated shake' : clicked}]"
                        v-if="clicked">{{
                        errors.first('nombre') }}</span>
                </div>

                <div class="contenedor-input -middle">
                    <label for="">Apellidos*</label>
                    <input type="text" name="apellidos"
                        v-model="inscripcion.apellidos"
                        v-validate="'required'">
                    <span :class="['error',{'animated shake' : clicked}]"
                        v-if="clicked">{{
                        errors.first('apellidos') }}</span>
                </div>

                <div class="contenedor-input -middle">
                    <label for="">Email*</label>
                    <input type="text" name="email"
                        v-validate="'required|email'"
                        v-model="inscripcion.email">
                    <span :class="['error',{'animated shake' : clicked}]"
                        v-if="clicked">{{
                        errors.first('email') }}</span>
                </div>


                <div class="contenedor-input -middle">
                    <label for="">Teléfono*</label>
                    <input type="number" name="telefono" v-validate="'required'"
                        v-model="inscripcion.telefono">
                    <span :class="['error',{'animated shake' : clicked}]"
                        v-if="clicked">{{
                        errors.first('telefono') }}</span>
                </div>

                <div class="contenedor-input -full">
                    <label for="">Observaciones</label>
                    <textarea name="observaciones"
                        v-model="inscripcion.observaciones"></textarea>
                </div>

                <div class="contenedor-boton">
                    <button class="btn" @click="inscribirse"
                        :loading="loadinginscripcion">Inscribirme</button>
                </div>

            </div>


        </div>
    </div>

</template>

<script lang="js">

    import { mapGetters, mapActions } from 'vuex';
    
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

	export default {
        name: 'popup-inscripcion-evento',
        props : ['id'],
        mounted(){
            this.inscripcion.urlAcceso = this.id;
            this.requestBasicosAlumno().then(r => {
            this.inscripcion =  {
                    nombre: r.nombre,
                    apellidos:r.apellido1,
                    email: r.email,
                    telefono: r.telefono,
                    observaciones: "",
                    urlAcceso: this.inscripcion.urlAcceso
              };
          });
        },
		data() {
			return {
                clicked : false,
                loadinginscripcion: false,
                inscripcion : {
                    nombre: "",
                    apellidos: "",
                    email: "",
                    telefono: "",
                    observaciones: "",
                    urlAcceso: ""
                }
			}
        },
        methods : {
            ...mapActions(['requestEvento','inscripcionEvento','requestBasicosAlumno']),
            inscribirse(){
                    this.clicked = true;
                    this.loadinginscripcion = true;
                    this.$validator.validateAll()
                    .then(itsOk => {
                        if (itsOk) {
                            this.loadinginscripcion = true;
                            this.inscripcionEvento(this.inscripcion).then(r => {
                                this.loadinginscripcion = false;
                                this.$emit('inscrito');
                                this.$emit('close');
                            });
                        }
                });
            }
        }
	}
</script>

<style scoped lang="scss">

    p{
        margin-bottom: 15px;
    }

</style>


// WEBPACK FOOTER //
// src/components/parts/popup-inscripcion-evento.vue